export default __webpack_public_path__ + "static/media/jobForm.db6ef95e.png";